define([
	"dojo/_base/declare",
	"csi/def/ViewRef",
	"csi/table/Aggregate",
	"csi/xml",
	"SiteAdmin"
], function(declare, ViewRef, Aggregate, xml, SiteAdmin) {

	return declare(Aggregate, {
		// @property {boolean} isForAssignedAgentCrew - indicates whether the table is for AssignedAgentCrewRoleUsers
		isForAssignedAgentCrew: false,
		/**
		 * @override
		 * Add current selections to form data
		 */
		onFormData(fd) {
			const reportType = "CrewAssignmentReport";
			const {m_cache, m_urlNode} = this;

			m_cache.query().forEach(({$Type, CrewDistance, Role, User}) => {
				if (($Type === reportType) && (Role === m_urlNode) && (CrewDistance === 0)) {
					const user = m_cache.get(User);
					fd.addAggregatedNode(user);
				}
			});
		},

		toWriterRequest: function() {
			const writer = this.inherited(arguments);
			const crew = SiteAdmin.getOnlineSupplierCrew(this.getCache(),this.widget.getViewNode(),this.isForAssignedAgentCrew);
			writer.addParameter("Crew", xml.ATTR_REF, crew);
			return writer;
		},

		/**
		 * @override
		 * Fix duplicate rows on initially clicking save when adding users to roles
		 */
		postProcessSuccess: function() {
			return this.widget.refreshData();
		},

		/**
		 * @override
		 * Use ProductSourceActiveSiteUsers view if we are on a ProductSource TeamView, ActiveSiteUsers otherwise
		 */
		getActionView: function(vr) {
			var crewHolder = this.widget.getViewNode().__Parent__;
			vr = new ViewRef();
			vr.m_id = "AvailableCrewRoleUsers";
			vr.m_url = crewHolder;
			return this.inherited(arguments, [vr]);
		},

		/**
		 * @override
		 * Set parameters for the current CrewURL and RoleURL, used for GetProductSourceCrewUsers
		 */
		onCreatePopupDefView: function(defView) {
			defView.getPageRelationship().m_parameters = {"CrewURL": this.widget.urlRoot, "RoleURL": this.m_urlNode};
		},

		/**
		 * Pass isForAssignedAgentCrew to the popup params - used on the AvailableCrewRoleUsers view controller AvailableCrewRoleUsersTable
		 * @param {Object} params
		 */
		onCreatePopupParams: function(params) {
			params.isForAssignedAgentCrew = this.isForAssignedAgentCrew;
		},
	});
});